// Картка #855: бек приставляє бренд до назви, якщо назва не починається з нього дослівно
// (OrderReturnService::get_order_transfer_data, m_basket::get_goods_in_cart, SQL каталогу
// m_get_goods::getGoodsAccountQuery і БУ-каталогу, індекс пошуку, звіт завантаження XLS).
// Бренд «MANN FILTER» і назва «MANN-FILTER Фільтр мастил» дають «MANN FILTER MANN-FILTER Фільтр мастил».
// Прибираємо приставку, якщо одразу після неї йде той самий бренд, записаний з іншими
// пробілами/дефісами/крапками чи регістром. Інші назви не чіпаємо: «Mahle / Knecht Mahle …»
// чи «Mobil (USA) Mobil 1 …» - це вже не той самий запис бренду.
const notAlnum = '[^\\p{L}\\p{N}]*';
const alnum = /[\p{L}\p{N}]/u;

// Бек не віддав бренд окремо: бренд шукаємо серед перших слів назви («MANN FILTER», «Hyundai / Kia»)
const maxBrandWords = 4;

function brandChars(brand: string): string[] {
  return Array.from(brand.toLowerCase()).filter(ch => alnum.test(ch));
}

/** text починається з тих самих літер і цифр бренду (з будь-якими розділювачами між ними) і на межі слова */
function startsWithSameBrand(text: string, chars: string[]): boolean {
  return new RegExp('^' + chars.join(notAlnum) + '(?![\\p{L}\\p{N}])', 'iu').test(text);
}

/** Назва без повтору бренду на початку; бренд порожній або повтору немає - назва як є */
export function removeDuplicateBrand(name: string, brand: string): string {
  if (typeof name !== 'string' || typeof brand !== 'string') {
    return name;
  }

  const brandTrimmed = brand.trim();
  const head = name.trimStart();
  if (!brandTrimmed || head.substring(0, brandTrimmed.length).toLowerCase() !== brandTrimmed.toLowerCase()) {
    return name;
  }

  // Бренд - окреме слово: «MANN FILTERS …» не чіпаємо
  const rest = head.substring(brandTrimmed.length);
  if (!/^\s/.test(rest)) {
    return name;
  }

  const chars = brandChars(brandTrimmed);
  if (!chars.length) {
    return name;
  }

  const restTrimmed = rest.trimStart();

  return startsWithSameBrand(restTrimmed, chars) ? restTrimmed : name;
}

/**
 * Те саме для відповідей, де бренду окремим полем немає (каталог, картка товару й аналоги,
 * підказки пошуку, звіт завантаження XLS): бренд - перші слова назви, якщо одразу за ними
 * йдуть ті самі літери й цифри в іншому написанні. «MANN FILTER Оливний фільтр» не чіпаємо.
 */
export function removeRepeatedBrand(name: string): string {
  if (typeof name !== 'string') {
    return name;
  }

  const head = name.trimStart();
  const spaces = /\s+/g;

  for (let words = 1; words <= maxBrandWords; words++) {
    const space = spaces.exec(head);
    if (!space) {
      break;
    }

    // Один символ («A», «3») - не бренд, повтор випадковий
    const chars = brandChars(head.substring(0, space.index));
    const rest = head.substring(space.index + space[0].length);

    if (chars.length > 1 && startsWithSameBrand(rest, chars)) {
      return rest;
    }
  }

  return name;
}
